import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';

import { NumericStepper } from '../../TripDetails/NumericStepper';
import { serviceDetailsNameRoot } from './ServiceDetailsFormBody';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

interface AdditionalPassengersContextFieldProps {
  fieldName?: string;
}
export function AdditionalPassengersContextField({
  fieldName = `${serviceDetailsNameRoot}.num_accompanying_passengers`,
}: AdditionalPassengersContextFieldProps) {
  return (
    <FormFieldController name={fieldName}>
      {({ field, fieldState }) => {
        return (
          <DefaultFormFieldLayout
            label="Additional passengers"
            error={fieldState.error?.message?.toString()}
            inputId={fieldName}
          >
            <NumericStepper
              {...field}
              onChange={(e: any) => {
                field.onChange(Number(e.target.value));
              }}
              min={0}
            />
          </DefaultFormFieldLayout>
        );
      }}
    </FormFieldController>
  );
}
